import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
export type TitleProps = {
  children: React.ReactNode;
  size?: "md" | "lg";
};
export function Title({ children, size = "md" }: TitleProps) {
  const scaffold = useScaffold();
  return (
    <div
      className={clsx(
        "text-pretty",
        size === "lg"
          ? "font-semibold text-display-sm"
          : "font-medium text-display-xs",
        scaffold.page.colors.text.primary,
      )}
    >
      {children}
    </div>
  );
}
